import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { ProgramStatusType } from "shared/types/ProgramStatusType";
import { useGetApiData } from "shared/datalayer";

export function useGetProgramSkippedTimelines({ programParticipantId }: { programParticipantId?: string }) {
  return useGetApiData<Array<ProgramStatusType>>(
    MyExpApi.SKIPPED_TIMELINE_STAGES_LIST_BY_PROGRAM_ID,
    { params: { programParticipantId } },
    { enabled: Boolean(programParticipantId) }
  );
}
